<main class="loyale-auth-page loyale-auth-page--centered" aria-label="Loading workspace">
  <div class="auth-brand"><img src="../../../assets/logo.svg" alt="Loyale"></div>
</main>
